/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileLocation_geography = {
    readonly countries: ReadonlyArray<{
        readonly name: string | null;
        readonly abbreviation: string | null;
    } | null> | null;
    readonly " $refType": "ProfileLocation_geography";
};
export type ProfileLocation_geography$data = ProfileLocation_geography;
export type ProfileLocation_geography$key = {
    readonly " $data"?: ProfileLocation_geography$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileLocation_geography">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileLocation_geography",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GeographyObject",
      "kind": "LinkedField",
      "name": "countries",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "abbreviation",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Geography",
  "abstractKey": null
};
(node as any).hash = '7f3d03dcc413e8e1cb947ed93ebf6326';
export default node;
